import whoWeAreData from "@/i18n/json/who-we-are/data.json";
import { PromoEaster } from "../promo-easter/promo-easter";
import InvestorSection from "./investor-section";

interface IInvestorObj {
  [key: string]: {
    name: string;
    linkedIn: string;
    title: string;
    alt: string;
  }[];
}

const Investors: React.FC = () => {
  const investorObj: IInvestorObj = whoWeAreData;

  return (
    <>
      {Object.keys(investorObj).map((item: string, index: number) => {
        return (
          <InvestorSection
            key={index}
            investorType={item}
            investors={investorObj[item]}
            isDark={(index + 1) % 2 !== 0}
            isEven={
              investorObj[item].length % 2 === 0 && investorObj[item].length < 5
            }
          >
            {index === 2 && <PromoEaster day={2} />}
          </InvestorSection>
        );
      })}
      {/* <br /> */}
    </>
  );
};

export default Investors;
